module.exports = __webpack_public_path__ + "img/traffic-phone-icon.f9378768.svg";